import Vue from 'vue'
import VueScroller from 'vue-scroller'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import './registerServiceWorker'

var VueCookie = require('vue-cookie');

Vue.use(VueScroller)
Vue.use(VueCookie);

Vue.config.productionTip = false

Vue.prototype.$globalData = Vue.observable({
  appLang: 'nl', 
  appData: {
    user: {
      voornaam: '',
      achternaam: '',
      voorletters: '',
      email: '',
    },
  },
});


axios.defaults.withCredentials = true

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
